import {
  type OrganizationMemberResponse,
  OrganizationMemberStatus,
} from "../api";
import { Utility } from "./utility";

export enum OrganizationMemberRoleLabel {
  admin = "Admin",
  member = "Member",
}

export interface OrganizationMember extends OrganizationMemberResponse {
  get_local_time(time_string: string): Date;
}

export class OrganizationMember extends Utility<OrganizationMember> {
  constructor(init?: Partial<OrganizationMemberResponse>) {
    super();
    Object.assign(this, init);
  }

  get roleLabel(): OrganizationMemberRoleLabel {
    return this.is_admin
      ? OrganizationMemberRoleLabel.admin
      : OrganizationMemberRoleLabel.member;
  }

  get deactivated(): boolean {
    return this.status === OrganizationMemberStatus.Deactivated;
  }

  query(query: string): boolean {
    return (
      this.name?.toLowerCase().includes(query.toLowerCase()) ||
      this.email?.toLowerCase().includes(query.toLowerCase()) ||
      false
    );
  }
}
